import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';

export default class ToggleMenuButtonStyle extends Enhancer {
    init() {
        this.element.addEventListener('click', this.handleClick.bind(this));
        // When menu is closed with esc in nav-pane the button gets focus,
        // this is unfortunately the only way we can call the function
        this.button.addEventListener('focus', this.handleClick.bind(this));
    }

    handleClick() {
        if (this.button.getAttribute('aria-expanded') === 'true') {
            if (this.buttonText != null) {
                this.buttonText.innerHTML = this.showButtonTextValue;
            }

            this.hideIcon.classList.add('d-none');
            this.showIcon.classList.remove('d-none');

            if (this.hideNavbar === 'true') {
                this.navBar.style.visibility = 'hidden';
            }
        } else {
            if (this.buttonText != null) {
                this.buttonText.innerHTML = this.hideButtonTextValue;
            }

            this.hideIcon.classList.remove('d-none');
            this.showIcon.classList.add('d-none');

            if (this.hideNavbar === 'true') {
                this.navBar.style.visibility = 'visible';
            }
        }
    }

    get button() {
        return this.element.querySelector('.toggle-button');
    }

    get buttonText() {
        return this.element.querySelector('.nav-pane-button-text');
    }

    get showButtonTextValue() {
        return this.element.dataset.showButtonText;
    }

    get hideButtonTextValue() {
        return this.element.dataset.hideButtonText;
    }

    get showIcon() {
        return this.element.querySelector('.icon-show');
    }

    get hideIcon() {
        return this.element.querySelector('.icon-hide');
    }

    get hideNavbar() {
        return this.element.dataset.hideNavbar;
    }

    get navBar() {
        return document.querySelector('.navbar-desktop');
    }
}

EnhancerApp.register('ToggleMenuButtonStyle', ToggleMenuButtonStyle);
